/**
 * The floating add button.
 *
 * It used to expand into three intake paths. Two of them are gone: speaking was
 * removed, and scanning stopped being a separate way IN — the camera now lives
 * inside the add form, filling one field at a time
 * (`app/src/camera/CaptureSheet.tsx`).
 *
 * With one destination left, the expanding menu was a tap that asked a question
 * with a single answer. So the button just goes there.
 */
export function AddFab({ onAdd }: { onAdd: () => void }) {
  return (
    <div className="fabwrap">
      <button
        type="button"
        className="fab"
        onClick={onAdd}
        aria-label="Add something"
        data-testid="fab"
      >
        <span className="fabicon" aria-hidden="true">
          ＋
        </span>
      </button>
    </div>
  );
}
